import {
	NeedsApprovalTransactionsQuery,
	NeedsApprovalTransactionsQueryVariables,
	TransactionType,
	useNeedsApprovalTransactionsQuery
} from '../../../graphql'
import * as ApolloReactHooks from '@apollo/client'
import { EuiButton, EuiButtonEmpty, EuiFlexGroup, EuiFlexItem, EuiPopover } from '@equipmentshare/ds2'
import { useState } from 'react'
import groupTransactions from './helpers/groupTransactions'
import { optionConfig } from './helpers/optionConfig'

import {
	ArrowDownSLineIcon,
	ArrowUpSLineIcon,
} from '@equipmentshare/ds2-icons'
import { useNavigate } from 'react-router-dom'

const maxResultSize = 1000
const ONE_MINUTE_IN_MS = 1000 * 60

export type NeedsApprovalPopoverProps = {
	storeIds: number[],
	onClick?: () => void,
};

export default function NeedsApprovalPopover( { storeIds, onClick }: NeedsApprovalPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )
	const navigate = useNavigate()

	const options: ApolloReactHooks.QueryHookOptions<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables> = {
		variables: {
			fromIds: storeIds.length > 0 ? storeIds : undefined,
			size: maxResultSize
		},
		pollInterval: ONE_MINUTE_IN_MS,
	}
	const { data } = useNeedsApprovalTransactionsQuery( options )
	const { count, transactions } = groupTransactions( data )

	const items = Object.entries( transactions ).map( ( [ transactionType, toAndFroms ] ) => {
		const option = ( storeIds && storeIds.length > 0 )
			? optionConfig.find( ( v ) => v.transactionType === transactionType && toAndFroms[ v.storeIdsKey ].some( ( id: number ) => storeIds.map( ( sid ) => sid.toString() ).includes( id.toString() ) ) )
			: optionConfig.find( ( v ) => ( ( transactionType === TransactionType.StoreToStore || transactionType === TransactionType.StoreToWorkOrder ) ? v.transactionType === transactionType : undefined ) )

		return option &&
				<EuiFlexItem key={option.key}>
					<EuiButtonEmpty
						onClick={() => navigate( option.route )}
					>
						{option.label}
					</EuiButtonEmpty>
				</EuiFlexItem>
	} )

	const onButtonClick = () => {
		onClick?.()
		togglePopover()
	}

	const button = (
		<EuiButton
			color="danger"
			iconSide="right"
			iconType={isPopoverOpen ? ArrowUpSLineIcon : ArrowDownSLineIcon}
			onClick={onButtonClick}
			isDisabled={count === 0}
		>
			Needs approval ({`${count}${( count === maxResultSize ) ? '+' : ''}`})
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={closePopover}
		>
			<EuiFlexGroup direction="column" alignItems="flexStart">

				{items}

			</EuiFlexGroup>
		</EuiPopover>
	)
}
